import type { DrawLevel } from '@ps/web-shared-api-types/v1-preview/SwPkrSpinAndGo';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';

import sharedStyles from '../shared.scss';

import { TXTCLI_Level_Time_1, TXTCLI_min_1, TXTCLI_mins_1 } from './TimeLimits.messages.json';
import styles from './TimeLimits.scss';

const LevelsLength = ({ timeInSeconds }: { timeInSeconds: number }) => {
  const min = timeInSeconds / 60;
  return (
    <tr className="time-limits-table-body-row">
      <td className="time-limits-table-body-cell">
        {min}{' '}
        {
          min === 1 ? (
            <Translation {...TXTCLI_min_1} /> // 1 min
          ) : (
            <Translation {...TXTCLI_mins_1} />
          ) // 2 mins
        }
      </td>
    </tr>
  );
};

export const TimeLimits: React.FC<{ drawLevels: DrawLevel[] }> = ({
  drawLevels
}: {
  drawLevels: DrawLevel[];
}) => (
  <table className={classNames(sharedStyles.scrollableTable, styles.timeLimitsTable)}>
    <thead className="time-limits-table-header">
      <tr className="time-limits-table-header-row">
        <th className="time-limits-table-header-cell">
          <Translation {...TXTCLI_Level_Time_1} />
        </th>
      </tr>
    </thead>
    <tbody className="time-limits-table-body">
      {drawLevels.map(
        ({ avgLevelsLength }, index) =>
          avgLevelsLength && <LevelsLength key={index} timeInSeconds={avgLevelsLength} />
      )}
    </tbody>
  </table>
);
